import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

type AdminMenuItem = {
  label: string;
  path: string;
  icon: string;
  submenu?: AdminMenuItem[];
};

const menuItems: AdminMenuItem[] = [
  {
    label: 'Painel de Controle',
    path: '/admin/control-panel',
    icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6',
  },
  {
    label: 'Documentos',
    path: '/admin/documents',
    icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
    submenu: [
      {
        label: 'Tipos de Documentos',
        path: '/admin/documents/types',
        icon: 'M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z',
      },
      {
        label: 'Tipos de Relacionamento',
        path: '/admin/documents/relationship-types',
        icon: 'M17 8h2a2 2 0 012 2v4a2 2 0 01-2 2h-2m-10 0H5a2 2 0 01-2-2v-4a2 2 0 012-2h2m6 8V8m0 0l-3 3m3-3l3 3',
      },
    ],
  },
  {
    label: 'Workflow',
    path: '/admin/workflow',
    icon: 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10',
    submenu: [
      {
        label: 'Workflows',
        path: '/admin/workflow/workflows',
        icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2',
      },
      {
        label: 'Associação de Workflow',
        path: '/admin/workflow-association-rules',
        icon: 'M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1',
      },
      {
        label: 'Calendário Corporativo',
        path: '/admin/workflow/calendar',
        icon: 'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z',
      },
      {
        label: 'SLAs',
        path: '/admin/workflow/sla',
        icon: 'M12 8c-2.21 0-4 1.79-4 4m8 0a4 4 0 10-8 0m8 0H8m4 0v4m6 4H6a2 2 0 01-2-2v-1a8 8 0 1116 0v1a2 2 0 01-2 2z',
      },
      {
        label: 'Dashboard de SLA',
        path: '/admin/workflow/sla-dashboard',
        icon: 'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
      },
    ],
  },
  {
    label: 'Sistema',
    path: '/admin/system',
    icon: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z',
  },
  {
    path: '/chatbot-admin/workspaces',
    label: 'Chatbots',
    icon: 'M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z',
  },
  { path: '/admin/customers', label: 'Clientes', icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0' },
  { path: '/admin/users', label: 'Usuários', icon: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z' },
  { path: '/admin/plans', label: 'Planos', icon: 'M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z' },
  { path: '/admin/roles', label: 'Perfis', icon: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z' },
  { path: '/admin/permissions', label: 'Permissões', icon: 'M8 11V7a4 4 0 118 0m-4 8v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2z' },
  { path: '/admin/search', label: 'Pesquisa', icon: 'M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z' },
  {
    label: 'E-mails',
    path: '/admin/emails',
    icon: 'M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z',
    submenu: [
      {
        label: 'Templates de E-mail',
        path: '/admin/email-templates',
        icon: 'M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z',
      },
      {
        label: 'Filas',
        path: '/admin/email-queue',
        icon: 'M21.75 9v.906a2.25 2.25 0 01-1.183 1.981l-6.478 3.488M2.25 9v.906a2.25 2.25 0 001.183 1.981l6.478 3.488m8.839 2.51l-4.66-2.51m0 0l-1.023-.55a2.25 2.25 0 00-2.134 0l-1.022.55m0 0l-4.661 2.51m16.5-1.875a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75A2.25 2.25 0 014.5 4.5h15a2.25 2.25 0 012.25 2.25v9',
      },
    ],
  },
  { path: '/admin/settings', label: 'Configurações', icon: 'M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z' },
  {
    label: 'Processamentos',
    path: '/admin/jobs',
    icon: 'M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15',
    submenu: [
      {
        label: 'Monitoramento',
        path: '/admin/jobs',
        icon: 'M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15',
      },
      {
        label: 'Configurar Visibilidade',
        path: '/admin/job-visibility',
        icon: 'M15 12a3 3 0 11-6 0 3 3 0 016 0z M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z',
      },
    ],
  },
  { path: '/admin/logs', label: 'Logs', icon: 'M9 17v-2a4 4 0 014-4h3m4 0a9 9 0 11-18 0 9 9 0 0118 0z' },
];

function itemOrChildActive(pathname: string, item: AdminMenuItem): boolean {
  if (pathname.startsWith(item.path)) {
    return true;
  }
  if (item.path === '/admin/workflow' && pathname.startsWith('/admin/workflow-association')) {
    return true;
  }
  return item.submenu?.some(sub => pathname.startsWith(sub.path)) ?? false;
}

function subItemActive(pathname: string, subPath: string): boolean {
  return pathname === subPath || pathname.startsWith(`${subPath}/`);
}

export const AdminSidebar: React.FC<{
  mobileOpen?: boolean;
  onMobileClose?: () => void;
}> = ({ mobileOpen = false, onMobileClose }) => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const [expandedMenus, setExpandedMenus] = useState<string[]>([]);

  useEffect(() => {
    const parents: string[] = [];
    for (const item of menuItems) {
      if (item.submenu?.some(sub => subItemActive(location.pathname, sub.path))) {
        parents.push(item.path);
      }
    }
    if (parents.length === 0) return;
    setExpandedMenus(prev => {
      const merged = new Set([...prev, ...parents]);
      return Array.from(merged);
    });
  }, [location.pathname]);

  const toggleSubmenu = (path: string) => {
    setExpandedMenus(prev => (prev.includes(path) ? prev.filter(p => p !== path) : [...prev, path]));
  };

  const isSubmenuExpanded = (path: string) => expandedMenus.includes(path);

  return (
    <>
      {mobileOpen && (
        <button
          type="button"
          className="fixed inset-0 z-40 bg-black/40 md:hidden"
          aria-label="Fechar menu"
          onClick={onMobileClose}
        />
      )}
      <aside
        className={`bg-white shadow-md flex flex-col flex-shrink-0 z-50 h-full min-h-0 fixed inset-y-0 left-0 w-64 transition-transform duration-200 md:static md:z-40 ${
          collapsed ? 'md:w-20' : 'md:w-64'
        } ${mobileOpen ? 'translate-x-0' : '-translate-x-full pointer-events-none md:pointer-events-auto md:translate-x-0'}`}
      >
      <div
        className={`border-b border-gray-200 flex items-center justify-between p-4 ${
          collapsed ? 'md:flex-col md:items-center md:gap-1 md:px-2 md:py-3' : ''
        }`}
      >
        <img src="/logo.png" alt="Logo" className="h-8" />
        <button
          className="md:hidden flex items-center justify-center p-2 rounded hover:bg-blue-50 focus:outline-none"
          onClick={onMobileClose}
          aria-label="Fechar menu"
          type="button"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <button
          className="hidden md:flex items-center justify-center p-2 rounded hover:bg-blue-50 focus:outline-none"
          onClick={() => {
            setCollapsed(c => !c);
          }}
          aria-label={collapsed ? 'Expandir menu' : 'Recolher menu'}
          type="button"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            {collapsed ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            )}
          </svg>
        </button>
      </div>

      <div className="md:hidden px-3 py-3 border-b border-gray-200 space-y-1">
        <Link
          to="/admin/customers"
          onClick={onMobileClose}
          className={`block rounded-md px-3 py-2 text-sm font-medium ${
            location.pathname.startsWith('/admin/customers') ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-50'
          }`}
        >
          Clientes
        </Link>
        <Link
          to="/admin/system"
          onClick={onMobileClose}
          className={`block rounded-md px-3 py-2 text-sm font-medium ${
            location.pathname.startsWith('/admin/system') ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-50'
          }`}
        >
          Sistema
        </Link>
        <Link
          to="/admin/settings"
          onClick={onMobileClose}
          className={`block rounded-md px-3 py-2 text-sm font-medium ${
            location.pathname.startsWith('/admin/settings') ? 'bg-blue-50 text-blue-700' : 'text-gray-700 hover:bg-gray-50'
          }`}
        >
          Configurações
        </Link>
        <Link
          to="/"
          onClick={onMobileClose}
          className="block rounded-md px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Voltar para Aplicação
        </Link>
      </div>

      <nav className="flex-1 overflow-y-auto">
        <ul>
          {menuItems.map(item => (
            <li key={item.path} className="mb-2">
              {item.submenu ? (
                <div>
                  <button
                    type="button"
                    onClick={() => toggleSubmenu(item.path)}
                    className={`w-full flex items-center px-4 py-2 rounded-md transition-colors duration-150 ${
                      itemOrChildActive(location.pathname, item) ? 'bg-blue-900 text-white' : 'text-blue-900 hover:bg-blue-50'
                    } ${collapsed ? 'md:justify-center' : ''}`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className={`h-5 w-5 flex-shrink-0 mr-3 ${collapsed ? 'md:mr-0' : ''} ${
                        itemOrChildActive(location.pathname, item) ? 'text-white' : 'text-blue-900'
                      }`}
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={item.icon} />
                    </svg>
                      <span className={`flex-1 text-left ${collapsed ? 'md:hidden' : ''}`}>{item.label}</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className={`h-4 w-4 flex-shrink-0 transition-transform duration-200 ${collapsed ? 'md:hidden' : ''} ${
                          isSubmenuExpanded(item.path) ? 'rotate-180' : ''
                        }`}
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                  </button>

                  {(!collapsed || mobileOpen) && isSubmenuExpanded(item.path) && (
                    <ul className={`mt-1 ml-2 space-y-1 border-l border-blue-100 pl-2 ${collapsed ? 'md:hidden' : ''}`}>
                      {item.submenu.map(subItem => (
                        <li key={subItem.path}>
                          <Link
                            to={subItem.path}
                            onClick={onMobileClose}
                            className={`flex items-center px-3 py-2 rounded-md transition-colors duration-150 text-sm ${
                              subItemActive(location.pathname, subItem.path)
                                ? 'bg-blue-900 text-white'
                                : 'text-blue-900 hover:bg-blue-50'
                            }`}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              className={`h-4 w-4 mr-2 flex-shrink-0 ${
                                subItemActive(location.pathname, subItem.path) ? 'text-white' : 'text-blue-900'
                              }`}
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke="currentColor"
                            >
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={subItem.icon} />
                            </svg>
                            <span>{subItem.label}</span>
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              ) : (
                <Link
                  to={item.path}
                  onClick={onMobileClose}
                  className={`flex items-center px-4 py-2 rounded-md transition-colors duration-150 ${
                    location.pathname === item.path || location.pathname.startsWith(`${item.path}/`)
                      ? 'bg-blue-900 text-white'
                      : 'text-blue-900 hover:bg-blue-50'
                  } ${collapsed ? 'md:justify-center' : ''}`}
                  tabIndex={0}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={`h-5 w-5 flex-shrink-0 mr-3 ${collapsed ? 'md:mr-0' : ''} ${
                      location.pathname === item.path || location.pathname.startsWith(`${item.path}/`)
                        ? 'text-white'
                        : 'text-blue-900'
                    }`}
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={item.icon} />
                  </svg>
                  <span className={`transition-all duration-200 ${collapsed ? 'md:hidden' : ''}`}>{item.label}</span>
                </Link>
              )}
            </li>
          ))}
        </ul>
      </nav>
      </aside>
    </>
  );
};
